import styled from "styled-components";
import { V3HeadlineH4 } from "../Typography";

export const BlogTagsDisplayWrapper = styled.div`
    display: inline-block;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const BlogTagsDisplayContainer = styled.div`
    padding: 4px;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
    border-radius: 200px;
    display: flex;
    background: white;
    width: auto;

    > * {
        &:not(:last-child) {
            margin-right: 8px;
        }
    }
`;

export const BlogTagItemName = styled(V3HeadlineH4)`
    font-weight: 500;
    color: ${({ theme }) => theme.v3.colors.grey48};
`;

export const BlogTagItem = styled.div<{ active?: boolean }>`
    padding: 12px;
    border-radius: 36px;
    padding: 12px 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    background: ${({ active, theme }) => active ? theme.v3.colors.grey96 : null};

    ${BlogTagItemName} {
        color: ${({ active, theme }) => active ? theme.v3.colors.ink : null};
    }

    > div {
        display: inline-flex;

        &:nth-child(2) {
            margin-left: 5px
        }
    }

    &:hover {
        background: ${({ theme }) => theme.v3.colors.grey96};

        ${BlogTagItemName} {
            color: ${({ theme }) => theme.v3.colors.ink};
        }
    }
`;